import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#516aff";
function BAND({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M13.68 9.378l1.65.943V5.606l-3.3-1.65-5.127 2.888v10.253l5.127 2.947 5.067-3.005V11.97l-4.891-2.947-1.65.825 4.891 2.888.059 3.477-3.476 1.944-3.537-2.004V7.67l3.537-1.945 1.65.884z" /><path  d="M11.853 12.206l1.12-.59 1.237.767-3.654 2.063v-4.243l1.297.766" /></Svg>;
}
BAND.DefaultColor = DefaultColor;
export default BAND;